import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './Relogin.scss'
import Login from '../../Pages/Login';

const Relogin = (props) => {
    if(!props.reloginUser) {
        return null;
    }
    const reloginWrapperClass = 'relogin-overlay-html' + (props.reloginUser ? ' active': '');
    let currentEmail = '';
    try {
        currentEmail = JSON.parse(window.localStorage.getItem('user_data'));
        currentEmail = currentEmail.email;
    } catch(e) {
        window.location.href = '/';
    }
    return (
        <div className = {reloginWrapperClass}>
            <Login 
                {...props}
                headerTitle="Oops!"
                headerMessage="Your session has expired. Please sign in again to continue with your work." 
                reloginState = {props.reloginUser} 
                currentEmail = {currentEmail}
            />
        </div>
    );
}

const mapStateToProps = state => {
    return {
        reloginUser: state.UiReducer && state.UiReducer.reloginUser ? state.UiReducer.reloginUser : false
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        
    },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Relogin);
